




















































































import { Component, Vue, Watch } from "vue-property-decorator";
import VisualAvailability from "./Components/VisualAvailability.vue";
import CalendarAvailability from "./Components/CalendarAvailability.vue";
import TimeLineAvailability from "./Components/TimeLineAvailability.vue";
import { LayoutModule } from "@/store/layout";
import AvailabilityFilter from "./Components/AvailabilityFilter.vue";
import { AvailabilityModule } from "@/store/availability";
import { AvailabilityFilterModel } from "@/models/availability";
import Site from "@/models/site";
import SitesAPI from "@/services/sites";
import { Dialog, QueryParams } from "@/models/general";
import AdUnitsAPI from "@/services/adUnits";
import AdUnit from "@/models/adUnit";
import CampaignsAPI from "@/services/campaigns";
import Campaign from "@/models/campaign";
import DefinitionsAPI from "@/services/definitions";
import { DefinitionList } from "@/models/definition";

import ExportExcel from "./Components/ExportExcel.vue";
import ReportsAPI from "@/services/reports";

@Component({
  components: {
    VisualAvailability,
    CalendarAvailability,
    TimeLineAvailability,
  },
})
export default class Availability extends Vue {
  tab = null;
  sites: Site[] = [];
  adUnits: AdUnit[] = [];
  campaigns: Campaign[] = [];
  definitions: DefinitionList[] = [];
  dataLoaded = false;

  get filter(): AvailabilityFilterModel | null {
    return AvailabilityModule.getFilter;
  }

  async created(): Promise<void> {
    AvailabilityModule.setFilter(null);
  }

  async loadData(): Promise<void> {
    LayoutModule.showLoader();
    this.dataLoaded = false;
    try {
      await this.getSites();
      await this.getAdUnits();
      await this.getCampaigns();
      await this.getDefinitions();
    } catch (e) {
      console.log(e);
    }
    this.dataLoaded = true;
    LayoutModule.hideLoader();
  }

  async getSites(): Promise<void> {
    const params: QueryParams = {
      page: {
        size: -1,
      },
    };
    const r = await SitesAPI.getSites(params);
    this.sites = r.data;
  }

  async getAdUnits(): Promise<void> {
    const params: QueryParams = {
      filter: {
        site_ids: this.filter?.site_id?.toString(),
      },
      fields: {
        ad_unit: ["id", "ref", "name", "definitionValueIds", "siteIds"].join(
          ","
        ),
      },
      page: {
        size: -1,
      },
    };

    const r = await AdUnitsAPI.list(params);

    this.adUnits = r.data;
  }

  async getCampaigns(): Promise<void> {
    const params: QueryParams = {
      page: { number: -1, size: -1 },
    };
    const r = await CampaignsAPI.all(params);

    this.campaigns = r.data;
  }

  async getDefinitions(): Promise<void> {
    const r = await DefinitionsAPI.list(-1, -1);
    this.definitions = r.data;
  }

  exportExcel(): void {
    const dialog: Dialog = new Dialog();
    dialog.title = this.$t("general.export") as string;
    dialog.cancelButton = this.$t("general.close") as string;
    dialog.successButton = {
      text: this.$t("general.export") as string,
      type: "success",
      closeDialog: false,
      callback: async () => {
        console.log(LayoutModule.getDialogModel);
        const r = await ReportsAPI.availabilityExportXls(
          LayoutModule.getDialogModel
        );
        const blob = new Blob([r], { type: "application/vnd.ms-excel" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `availability-${LayoutModule.getDialogModel.date}.xlsx`;
        a.click();
        URL.revokeObjectURL(a.href);
      },
    };

    dialog.component = ExportExcel;

    LayoutModule.setDialog(dialog);

    LayoutModule.showDialog();
  }

  showFilter(): void {
    const props = {
      disable_adunits: false,
      disable_dates: false,
    };

    if (this.tab === "visual") {
      props.disable_adunits = true;
      props.disable_dates = true;
    }

    LayoutModule.setRightDrawerComponent(AvailabilityFilter);
    LayoutModule.setRightDrawerComponentProps(props);
    LayoutModule.showRightDrawer();
  }

  @Watch("tab")
  resetFilter(): void {
    AvailabilityModule.setFilter(null);
  }

  @Watch("filter", { deep: true })
  onFilterChange(): void {
    this.loadData();
  }
}
